export class CardInformation{
    cartaoNumero:string;
    cartaoCvv:string;
    cartaoValidadeMes:number;
    cartaoValidadeAno:number;
}